import { actions } from '@app/action/transfers-received';
import { normalizeTransfer } from '@module/transfer/build';

const initialState = {
  isLoaded: false,
  list: [],
};

export default function(state = initialState, action) {
  const { type } = action;

  if (type === actions.RECEIVED_TRANSFERS_SUCCESS) {
    return {
      ...state,
      list: action.list.map(normalizeTransfer),
      isLoaded: true,
    };
  }

  return state;
}
